module.exports = __webpack_public_path__ + "img/407ed11.jpg";